// WAI-ARIA tabs for the save analyzer reports. The report renders tabSet(); the controller
// routes clicks on [data-tab] and keydowns on [role=tab] through nextTabId().

/** DOM id of one tab button, for focusing it after a re-render. */
export function tabId(prefix, group, id) {
  return `${prefix}-${group}-tab-${id}`
}

/**
 * A tablist plus the selected tab's panel. `tabs` is [[id, label, renderPanel]]; `selected`
 * must be one of the ids. `prefix` keeps ids unique per tool.
 */
export function tabSet({ prefix, group, label, tabs, selected, extraClass = "" }) {
  const active = tabs.find(([id]) => id === selected)
  const buttons = tabs.map(([id, text]) =>
    `<button type="button" role="tab" class="game-tool__tab" id="${tabId(prefix, group, id)}" data-tab="${id}" data-tab-group="${group}" ` +
    `aria-controls="${prefix}-${group}-panel" aria-selected="${id === selected}" tabindex="${id === selected ? 0 : -1}">${text}</button>`
  ).join("")
  return `
      <div class="game-tool__tabs${extraClass ? ` ${extraClass}` : ""}" role="tablist" aria-label="${label}">${buttons}</div>
      <div id="${prefix}-${group}-panel" role="tabpanel" aria-labelledby="${tabId(prefix, group, selected)}">${active[2]()}</div>`
}

export const SHOW_ALL_TAB = "all"

/**
 * `tabs` with a leading "Show all" tab that stacks every panel, each under a heading naming its tab.
 * Leave out tabs that shouldn't be stacked (e.g. a debug dump) before calling. Nested tab sets pass
 * `headingLevel` so their headings sit under the outer panel's.
 */
export function withShowAll(prefix, group, tabs, { headingLevel = 2 } = {}) {
  const h = `h${headingLevel}`
  const all = () => tabs.map(([id, text, renderPanel]) => {
    const headingId = `${prefix}-${group}-all-${id}`
    return `<section class="game-tool__all-section" aria-labelledby="${headingId}">` +
      `<${h} class="game-tool__all-heading" id="${headingId}">${text}</${h}>${renderPanel()}</section>`
  }).join("")
  return [[SHOW_ALL_TAB, "Show all", all], ...tabs]
}

/** The id Arrow keys, Home or End move to (wrapping), or null for any other key. */
export function nextTabId(event, ids, current) {
  const i = ids.indexOf(current)
  const next = { ArrowRight: i + 1, ArrowLeft: i - 1, Home: 0, End: ids.length - 1 }[event.key]
  if (next === undefined) return null
  event.preventDefault()
  return ids[(next + ids.length) % ids.length]
}
